import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const SITE_NAME = "정환교피부과의원";
const HOME_TITLE = "정환교피부과의원 | 안산 단원구 피부과";
const SITE_URL = "https://www.jhk-skin.com";
const DEFAULT_DESCRIPTION =
    "안산 단원구 정환교피부과의원. 두 세대에 걸쳐 이어온 진심 어린 진료로 피부염·아토피·건선·기미·탈모부터 레이저·리프팅·필러·보톡스까지 전문적으로 진료합니다.";
const SHARE_IMAGE = `${SITE_URL}/img/logo_new.png`;

const SEO = ({ title, description, pathname, image, noindex }) => {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : HOME_TITLE;
    const metaDescription = description || DEFAULT_DESCRIPTION;
    const canonical = pathname ? `${SITE_URL}${pathname}` : SITE_URL;
    const shareImage = image || SHARE_IMAGE;

    return (
        <Helmet>
            <html lang="ko" />
            <meta charSet="utf-8" />
            <title>{pageTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
            />
            {noindex ? (
                <meta name="robots" content="noindex, follow" />
            ) : (
                <meta name="robots" content="index, follow" />
            )}
            <link rel="canonical" href={canonical} />

            {/* Open Graph / 공유 메타 */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={shareImage} />
            <meta property="og:locale" content="ko_KR" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={shareImage} />
        </Helmet>
    );
};

SEO.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    pathname: PropTypes.string,
    image: PropTypes.string,
    noindex: PropTypes.bool,
};

export default SEO;
